<template>

    <div class="ui-toast" @click="$emit('click')">
        <div class="icon"><i :class="icon"></i></div>

        <div class="content" v-if="subtitle">
            <p class="title">{{ title }}</p>
            <p class="subtitle">{{ subtitle }}</p>
        </div>
        <div class="content" v-else>
            <p class="title">{{ title }}</p>
        </div>

    </div>

</template>

<script lang="ts">

import { Component, Prop, Vue } from 'vue-facing-decorator';

import type { ComponentProps } from '@wittignl/js-core';
import { createComponentMixin } from '@wittignl/js-core';

@Component({
    name: 'ui-toast'
})
export default class Toast extends Vue {

    @Prop({ type: String })
    title: string;

    @Prop({ type: String })
    subtitle: string;

    @Prop({ type: String })
    icon: string;
}

export type ToastComp = InstanceType<typeof Toast>
export type ToastProps = ComponentProps<ToastComp>
export const toastCompMixin = createComponentMixin(Toast)

</script>

<style src="../../../scss/component/toast/Toast.scss" lang="scss"></style>